import TextInput from './TextInput';

class EmailInput extends TextInput {

}

export default EmailInput;
